import { render, staticRenderFns } from "./imgP.vue?vue&type=template&id=371ace17"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371ace17')) {
      api.createRecord('371ace17', component.options)
    } else {
      api.reload('371ace17', component.options)
    }
    module.hot.accept("./imgP.vue?vue&type=template&id=371ace17", function () {
      api.rerender('371ace17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgP.vue"
export default component.exports